import React from "react";

const Typography = ({ type, className, children }) => {
    // Desktop: 96px
    if (type === "96px")
        return (
            <p
                className={`font-kapraRegular text-center text-colorPrimary text-[2.5rem] leading-[2.688rem] tracking-[0.281rem] sm:text-[6rem] sm:leading-[4.8rem] sm:tracking-[0.06rem] ${className}`}
            >
                {children}
            </p>
        );
    // Desktop: 64px
    if (type === "64px")
        return (
            <p
                className={`font-kapraRegular text-center text-colorPrimary text-[2.5rem] leading-[2.688rem] tracking-[0.281rem] sm:text-[4rem] sm:leading-[3.2rem] sm:tracking-[0.4rem] ${className}`}
            >
                {children}
            </p>
        );
    // Desktop: 60px
    if (type === "h1")
        return (
            <p
                className={`font-kapraRegular text-center text-colorPrimary text-[2.5rem] leading-[2.688rem] tracking-[0.281rem] sm:text-[3.75rem] sm:leading-[4.125rem] sm:tracking-[0.5rem] ${className}`}
            >
                {children}
            </p>
        );

    // Desktop: 48px
    if (type === "48px") {
        return (
            <p
                className={`font-kapraRegular text-center text-colorPrimary text-[1.5rem] leading-[1.5rem] tracking-[0.125rem] sm:text-[3rem] sm:leading-[2.688rem] sm:tracking-[0.281rem] ${className}`}
            >
                {children}
            </p>
        );
    }
    // Desktop: 96px
    if (type === "96px") {
        return (
            <p
                className={`font-kapraRegular text-center text-colorPrimary text-4xl md:text-8xl tracking-[0.96px] leading-[2rem] sm:leading-[2.688rem] ${className}`}
            >
                {children}
            </p>
        );
    }

    // Desktop: 40px
    if (type === "h2")
        return (
            <p
                className={`font-kapraBold text-center text-colorPrimary text-[1.375rem] leading-[1.5rem] tracking-[0.125rem] sm:text-[2.5rem] sm:leading-[2.688rem] sm:tracking-[0.281rem] ${className}`}
            >
                {children}
            </p>
        );

    // Desktop: 30px
    if (type === "h3")
        return (
            <p
                className={`font-kapraBold text-center text-colorPrimary text-[1.875rem] leading-[2.063rem] tracking-[0.211rem] ${className}`}
            >
                {children}
            </p>
        );

    // Desktop: 24px
    if (type === "h4")
        return (
            <p
                className={`font-darwinProRegular text-center text-colorPrimary text-[1.5rem] leading-[1.5rem] tracking-[0.125rem] ${className}`}
            >
                {children}
            </p>
        );

    // Desktop: 22px
    if (type === "h5")
        return (
            <p
                className={`font-darwinProBold text-center text-colorPrimary text-[1.375rem] leading-[1.5rem] tracking-[0.125rem] ${className}`}
            >
                {children}
            </p>
        );

    // Desktop: 20px
    if (type === "h6")
        return (
            <p
                className={`font-darwinProRegular text-center text-colorPrimary text-base leading-[1.25rem]  sm:text-[1.25rem] sm:leading-[1.625rem] sm:tracking-[0.113rem] ${className}`}
            >
                {children}
            </p>
        );

    // Desktop: 18px | Mobile: 16px
    if (type === "body1")
        return (
            <p
                className={`font-darwinProRegular text-center text-colorPrimary text-base leading-[1.25rem] lg:text-[1.125rem] lg:leading-[1.75rem] ${className}`}
            >
                {children}
            </p>
        );

    // Desktop: 16px | Mobile: 14px
    if (type === "body2")
        return (
            <p
                className={`font-darwinProRegular text-center text-colorPrimary text-[0.875rem] leading-[1.25rem] lg:text-base lg:leading-[1.25rem] ${className}`}
            >
                {children}
            </p>
        );

    // Desktop: 14px | Mobile: 12px
    if (type === "body3")
        return (
            <p
                className={`font-darwinProRegular text-center text-colorPrimary text-[0.75rem] leading-[1rem] tracking-[0.031rem] lg:text-[0.875rem] lg:leading-[1.25rem] lg:tracking-[0.031rem] ${className}`}
            >
                {children}
            </p>
        );

    return <p></p>;
};

export default Typography;
